import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

const WalmartConnect = ({ history }) => {
  useEffect(() => {
    const isLoggedIn = !!localStorage.getItem('all3d_jwt_token');
    const WALMART_OAUTH_URL = `https://login.account.wal-mart.com/authorize?responseType=code&clientId=c4022037-a5fd-4886-a8df-3f72abbde99c&redirectUri=${encodeURIComponent('https://app.all3d.ai/walmart-callback')}&nonce=AVE1DCZ5FG&state=A0YFFJJQMD&clientType=seller`;

    if (isLoggedIn) {
      window.location.href = WALMART_OAUTH_URL;
    } else {
      history.replace(`/?returnTo=${encodeURIComponent('/walmart')}`);
    }
  }, [history]);

  return null;
};

export default withRouter(WalmartConnect);
